import { render, staticRenderFns } from "./AddStation.vue?vue&type=template&id=0f268072&scoped=true"
import script from "./AddStation.vue?vue&type=script&lang=js"
export * from "./AddStation.vue?vue&type=script&lang=js"
import style0 from "./AddStation.vue?vue&type=style&index=0&id=0f268072&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f268072",
  null
  
)

export default component.exports